<ng-container *ngIf="displayDialog" siAccessibilityDialog>
  <p-dialog [(visible)]="displayDialog"
            [modal]="true"
            [dismissableMask]="true"
            appendTo="body"
            styleClass="si-dialog-small">
    <div class="unsaved-changes-dialog">
      <div class="unsaved-changes-dialog_title">{{'SI_ATTENTION' | translate}}</div>
      <div class="unsaved-changes-dialog_text mt-3">
        <span>{{'SI_WITHOUT_FINISH' | translate}}</span>
        <span class="bold">{{'SI_CHANGES_LOST' | translate}}</span>
      </div>
      <div class="container-fluid px-0 mt-4">
        <div class="row no-gutters justify-content-center justify-content-sm-end">
          <div class="col-12 col-sm-auto mb-3 mb-sm-0">
            <button class="si-button_main w-100" (click)="onClickCloseDialog(false)">{{'SI_STAY' | translate}}</button>
          </div>
          <div class="col-12 col-sm-auto order-sm-first">
            <button class="si-button_cancel w-100 mt-1 mt-sm-0" (click)="onClickCloseDialog(true)">{{'SI_EXIT' | translate}}</button>
          </div>
        </div>
      </div>
    </div>
  </p-dialog>
</ng-container>
